import {InfoTable} from './infoTable';

export const NetworkTable = ({ title, data }) => {
    if (!data) return null;

    // The backend can report network info either as a full
    // [ip, subnet, ?, gateway, dns] array, or as a plain IP string when only
    // the address is known. Indexing a string like an array (data[0], data[1]...)
    // would split it into individual characters, so handle each shape explicitly.
    let networkInfo;
    if (Array.isArray(data)) {
      if (data.length < 5) return null;
      networkInfo = {
        ip: data[0],
        subnet: data[1],
        gateway: data[3],
        dns: data[4]
      };
    } else if (typeof data === 'string') {
      if (!data) return null;
      networkInfo = { ip: data };
    } else {
      return null;
    }

    const fields = [
      { label: 'IP', key: 'ip' },
      { label: 'Subnet', key: 'subnet' },
      { label: 'Gateway', key: 'gateway' },
      { label: 'DNS', key: 'dns' }
    ];
    return <InfoTable title={title} data={fields} statusInfo={networkInfo} />;
};